import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_MOBILE_NOTIFICATIONS_CONFIG = defineFcm('mobile_notifications_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				delete_notifications_older_than_days: { type: 'number' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-mobile',
		scope: 'mobile-service',
		context: 'Mobile Service',
		description: `Configuration for customizing the behaviour of the mobile service's handling of notifications.

		Currently used to configure the number of days that old notifications should be stored in the database before being deleted.`,
		import: false,
		template: {
			delete_notifications_older_than_days: 60,
		},
	});
